import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function LicenseIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33919 11.6415C8.33919 10.6015 9.31894 10.6999 10.5275 10.6999C11.7361 10.6999 12.7158 10.6015 12.7158 11.6415M12.0554 7.63639C12.0554 8.45227 11.3714 9.11366 10.5276 9.11366C9.68385 9.11366 8.99984 8.45227 8.99984 7.63639C8.99984 6.82052 9.68385 6.15912 10.5276 6.15912C11.3714 6.15912 12.0554 6.82052 12.0554 7.63639ZM3.33333 13.25H12.6665C13.679 13.25 14.4998 12.4563 14.4998 11.4773V6.75003V4.52273C14.4998 3.54368 13.679 2.75 12.6665 2.75H3.33333C2.32081 2.75 1.5 3.54368 1.5 4.52273V11.4773C1.5 12.4563 2.32081 13.25 3.33333 13.25Z"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
